// combatpro/treasure/treasureFormat.js
// Pure formatting helpers for treasure values/coins. No DOM, no em dash.
import { CATEGORY_LABELS } from './treasureVocab';

export function categoryLabel(cat) { return CATEGORY_LABELS[cat] || cat; }

// Format a normalized base-unit value as a compact coin string using the currency.
export function formatValue(baseValue, currency) {
  var v = Math.max(0, Math.round(baseValue || 0));
  if (!currency || !Array.isArray(currency.denominations) || !currency.denominations.length) { return String(v); }
  var denoms = currency.denominations.slice().sort(function (a, b) { return b.value - a.value; });
  var parts = [];
  for (var i = 0; i < denoms.length; i++) {
    var d = denoms[i];
    if (v >= d.value) {
      var n = Math.floor(v / d.value);
      v -= n * d.value;
      parts.push(n + ' ' + d.abbr);
    }
  }
  if (v > 0) { parts.push(v + ' ' + (denoms[denoms.length - 1].abbr)); }
  return parts.length ? parts.join(', ') : ('0 ' + denoms[denoms.length - 1].abbr);
}

export function formatCoins(counts, currency) {
  if (!counts || !currency) { return ''; }
  var denoms = (currency.denominations || []).slice().sort(function (a, b) { return b.value - a.value; });
  var parts = [];
  denoms.forEach(function (d) { if (counts[d.id] > 0) { parts.push(counts[d.id] + ' ' + d.abbr); } });
  return parts.join(', ');
}
